import {StreamsModule} from './streams/streams.module';
import {EntityChartModule} from './entity-chart/entity-chart.module';
import {NgModule} from '@angular/core';
import {TransactionModule} from './transaction/transaction.module';


@NgModule({
  declarations: [
  ],
  imports: [
    StreamsModule,
    EntityChartModule,
    TransactionModule
  ],
  exports: [StreamsModule, EntityChartModule, TransactionModule]
})
export class FootprintModule { }
